import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function PreventBackNavigation () {
    const navigate = useNavigate();

    function handlePopState (event){
        event.preventDefault();
        navigate(1);
    }

    useEffect(() => {
        
        window.addEventListener('popstate', handlePopState);

        return ()=> {
            window.removeEventListener('popstate', handlePopState);
        }
    }, []);

    return null;

}

export default PreventBackNavigation;